import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import OurteamBanner from './ourteam-banner';
import OurteamChairman from './ourteam-chairman'; 
import OurteamLeadership from './ourteam-leadership';
// import OurteamParallax from './ourteam-parallax'; 


function OurteamPage () {
    return(
      <Fragment> 
      <Header />  
      <OurteamBanner />     
      <OurteamChairman />  
      <OurteamLeadership />
      {/* <OurteamParallax />  */}
      <Footer /> 
      </Fragment> 
    );
}
export default OurteamPage;